module.exports = __webpack_public_path__ + "img/vessel_floor.d7413cb4.jpg";